import { useNavigate } from "react-router-dom";
import { LogoMark } from "@/components/site/Logo";
import { AuthForm } from "@/components/site/AuthForm";

export default function AuthPage() {
  const nav = useNavigate();
  return (
    <main className="min-h-screen grid place-items-center px-5 relative" data-testid="auth-page">
      <div className="absolute inset-0 grid-floor opacity-60" />
      <div className="relative glass rounded-[28px] p-8 sm:p-10 max-w-md w-full">
        <a href="/" className="inline-block"><LogoMark className="h-10 w-10 mb-6" /></a>
        <h1 className="font-display text-2xl font-bold mb-2">Your Frame Shift account</h1>
        <p className="text-slate-400 text-sm mb-8">Sign in to order edits and download your finished images.</p>
        <AuthForm onDone={(u) => nav(u?.role === "admin" ? "/admin" : "/my-orders")} />
      </div>
    </main>
  );
}
